<template>
  <v-app>
    <template v-if="showMainViews">
      <main-header
        :showHeader="showHeader"
        :headerTitle="HeaderTitle"
        :onClick="clickBackEvent"
      />
      <v-main app>
        <div fluid id="nav" class="contentContainer">
          <home-navigation
            @navigatorLoaded="homeLoaded"
            ref="homeNav"
            v-show="isHomeNavActive"
          />
          <notifications-navigation
            @navigatorLoaded="notiLoaded"
            ref="notificationNav"
            v-show="isNotificationNavActive"
          />
          <profile-navigation
            @navigatorLoaded="profileLoaded"
            ref="profileNav"
            v-show="isProfileNavActive"
          />
        </div>
      </v-main>
      <main-footer
        v-if="showMenu"
        :isHomeNavActive="isHomeNavActive"
        :isNotificationNavActive="isNotificationNavActive"
        :isProfileNavActive="isProfileNavActive"
        :clickEventHome="clickEventHome"
        :clickEventNotifications="clickEventNotifications"
        :clickEventProfile="clickEventProfile"
      />
    </template>

    <onboarding v-if="viewState === 'onboarding'" />
    <active-notifications
      v-if="viewState === 'active-notification'"
      @cancelAlert="viewStateCancelPushNotif"
    />
    <connecting-loader v-show="showConnecting" />
    <reload-required />
  </v-app>
</template>
<script>
import MainHeader from '@/components/header'
import MainFooter from '@/components/footer'
import ReloadRequired from '@/components/ReloadRequired'
import ConnectingLoader from '@/views/ConnectingLoader'
import OnBoarding from '@/views/Onboarding'
import ActiveNotification from '@/views/ActiveNotification'
import actions from '@chi-x/chi-login/lib/actions'
import { mapActions, mapGetters } from 'vuex'
import { daysFrom } from '@/helper/helper'
import { isApp } from '@/utils/ReactNative'
import { _ } from 'vue-underscore'
import { RegisterEvent } from '@/analytics'
import store from './store'
import HomeNavigation from '@/components/navigation/HomeNavigation'
import NotificationsNavigation from '@/components/navigation/NotificationsNavigation'
import ProfileNavigation from '@/components/navigation/ProfileNavigation'
import { router, NotificationNavRouter, ProfileNavRouter } from '@/router'

export default {
  store,
  data: () => ({
    isHomeMounted: false,
    isProfileMounted: false,
    isNotiMounted: false,
    badgeNumber: 0,
    authFinished: false,
    scrollPos: {},
    viewStateName: false
  }),
  components: {
    'main-header': MainHeader,
    'main-footer': MainFooter,
    ReloadRequired,
    ConnectingLoader,
    HomeNavigation,
    NotificationsNavigation,
    ProfileNavigation,
    onboarding: OnBoarding,
    'active-notifications': ActiveNotification
  },
  created () {
    const current = this
    this.firebaseAuthHandler()
      .then(data => {
        if (!_.isEmpty(data)) {
          const isMuted = this.$store.getters.getMuted
            ? 'chi_video_mute'
            : 'chi_video_unmute'
          RegisterEvent('chi_user_login', {
            target_id: data.uid,
            target_type: 'user_id'
          })
          RegisterEvent(isMuted, {
            target_id: 'chi_login',
            target_type: 'global_event'
          })
          this.profileAction()
        }
        current.authFinished = true
      })
      .catch(error => console.log(error))
    const target = this
    window.addEventListener('ReactNativeMessage', function (e) {
      target.saveDevice(e.detail)
    })
    const showNewVersionModal = this.showNewVersionModal
    window.addEventListener(
      'pwaNewVersionDetected',
      function (e) {
        showNewVersionModal()
      },
      false
    )

    const url = window.location.pathname + window.location.search
    if (url !== '' || url !== '/') {
      let resolved = router.resolve(url)
      if (undefined !== resolved.route.name) {
        router.push(resolved.route)
        this.ActiveHomeNav()
      } else {
        resolved = NotificationNavRouter.resolve(url)
        if (undefined !== resolved.route.name) {
          NotificationNavRouter.push(resolved.route)
          this.ActiveNotifNav()
        } else {
          resolved = ProfileNavRouter.resolve(url)
          if (undefined !== resolved.route.name) {
            ProfileNavRouter.push(resolved.route)
            this.ActiveProfileNav()
          }
        }
      }
    } else {
      this.ActiveHomeNav()
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'firebaseUUID',
      'getBadgeNotif',
      'getCheckedBadge',
      'getProfileData',
      'getDeviceInfo',
      'isHomeNavActive',
      'isNotificationNavActive',
      'isProfileNavActive',
      'getActiveNav',
      'getDocumentTitleName'
    ]),
    HeaderTitle () {
      // console.log(this.getDocumentTitleName, 'titleName')
      return this.getCurrentRoute.meta && this.getCurrentRoute.meta.titleName
        ? this.getCurrentRoute.meta.titleName(this.getCurrentRoute)
        : undefined
    },
    getCurrentNav: function () {
      if (this.isHomeMounted && this.isHomeNavActive) return this.$refs.homeNav
      if (this.isNotiMounted && this.isNotificationNavActive) {
        return this.$refs.notificationNav
      }
      if (this.isProfileMounted && this.isProfileNavActive) {
        return this.$refs.profileNav
      }
      return undefined
    },
    getCurrentRoute: function () {
      return this.getCurrentNav ? this.getCurrentNav.$route : {}
    },
    isConnecting: function () {
      // return !this.authFinished
      return this.isLoading && !this.authFinished
      // return !this.authFinishedthis.isAuthenticated()
    },
    isOnBoarding: function () {
      return this.$store.getters.getProfileData.onboarding
    },
    isLoading: function () {
      return !(
        this.isHomeMounted &&
        this.isNotiMounted &&
        this.isProfileMounted
      )
    },
    isActiveNotif: function () {
      let showActiveNotifView = false
      const isAuthenticated = this.isAuthenticated()
      const activeNotification = this.$store.getters.getProfileData
        .active_notification
      if (isApp && isAuthenticated && activeNotification) {
        const device = this.$store.getters.getDeviceInfo()
        const status = (device.pushNotifStatus || '').toUpperCase()
        const numDays = daysFrom(device.pushNotifUpdatedAt)
        switch (status) {
          case 'UNAVAILABLE':
            showActiveNotifView = false
            break
          case 'DENIED':
            showActiveNotifView = true
            break
          case 'LIMITED':
            showActiveNotifView = true
            break
          case 'GRANTED':
            showActiveNotifView = false
            break
          case 'BLOCKED':
            showActiveNotifView = numDays > 14
            break
          case 'NONE':
            showActiveNotifView = numDays > 0
            break
        }
      }
      return showActiveNotifView
    },
    viewState: function () {
      let viewState = this.viewStateName
      if (this.requiresAuth && !this.firebaseUUID) {
        viewState = 'none'
      }
      if (this.isAuthenticated()) {
        if (!viewState && this.isConnecting) viewState = 'connecting'
        if (!viewState && this.isOnBoarding) viewState = 'onboarding'
        if (!viewState && this.isActiveNotif) viewState = 'active-notification'
        if (!viewState) viewState = 'main-content'
      }
      if (!viewState) viewState = 'none'
      return viewState
    },
    requiresAuth: function () {
      if (this.getCurrentRoute && this.getCurrentRoute.meta) {
        const required = this.getCurrentRoute.meta.requiresAuth
        if (required && !this.firebaseUUID) {
          this.$store.dispatch(actions.AUTH_LOGOUT)
        }
        // if (required && this.firebaseUUID) {
        if (this.isAuthenticated() && required && this.firebaseUUID) {
          !this.getCheckedBadge && this.calcBadge()
        }
      }
      return false // required
    },
    showMainViews: function () {
      return this.viewState === 'none' || this.viewState === 'main-content'
    },
    showHeader: function () {
      return this.viewState === 'main-content'
    },
    showMenu: function () {
      return this.viewState === 'main-content'
    },
    showConnecting: function () {
      return this.viewState === 'connecting'
    }
  },
  methods: {
    ...mapActions({
      showNewVersionModal: 'NEW_VERSION_DETECTED',
      firebaseAuthHandler: 'FIREBASE_ACCESS',
      saveDeviceAction: 'DEVICE_ACTION',
      profileAction: 'GET_PROFILE',
      forceSSLAction: 'GET_FORCE_SSL',
      ActiveHomeNav: 'CHANGE_HOME_NAV',
      ActiveNotifNav: 'CHANGE_NOTIFICATIONS_NAV',
      ActiveProfileNav: 'CHANGE_PROFILE_NAV',
      calcBadge: 'CALC_BADGE'
    }),
    saveDevice (param) {
      this.saveDeviceAction(param)
    },
    homeLoaded () {
      if (isApp && this.viewState === 'main-content') this.isHomeMounted = true
      else if (!isApp && this.showMainViews) this.isHomeMounted = true
    },
    notiLoaded () {
      this.isNotiMounted = true
    },
    profileLoaded () {
      this.isProfileMounted = true
    },
    viewStateCancelPushNotif () {
      this.viewStateName = 'main-content'
    },
    resetMenuClick (navName) {
      if (this.getActiveNav === navName) {
        this.getCurrentNav.mainSite()
      }
    },
    clickBackEvent () {
      if (this.getCurrentNav) {
        if (this.getCurrentNav.$router.history.index === 0) {
          this.getCurrentNav.mainSite()
        } else this.getCurrentNav.$router.back()
        RegisterEvent('chi_go_back', {
          target_id: this.getCurrentNav.$router.currentRoute.name,
          from: this.getCurrentNav.$router.currentRoute.path,
          target_type: 'screen_name'
        })
      }
    },
    registerEventMenuSelected (menuName) {
      RegisterEvent('chi_menu_selected', {
        target_id: menuName
      })
    },
    clickEventHome () {
      this.scrollPos[this.getActiveNav] = window.scrollY
      if (this.getActiveNav === 'home') {
        this.resetMenuClick(this.getActiveNav)
      } else {
        this.ActiveHomeNav().then(() => {
          window.scrollTo(0, this.scrollPos.home)
          this.registerEventMenuSelected('home')
        })
      }
    },
    clickEventNotifications () {
      this.scrollPos[this.getActiveNav] = window.scrollY
      if (this.getActiveNav === 'notifications') {
        this.resetMenuClick(this.getActiveNav)
      } else {
        this.ActiveNotifNav().then(() => {
          window.scrollTo(0, this.scrollPos.notifications)
          this.registerEventMenuSelected('notifications')
        })
      }
    },
    clickEventProfile () {
      this.scrollPos[this.getActiveNav] = window.scrollY
      if (this.getActiveNav === 'profile') {
        this.resetMenuClick(this.getActiveNav)
      } else {
        this.ActiveProfileNav().then(() => {
          window.scrollTo(0, this.scrollPos.profile)
          this.registerEventMenuSelected('profile')
        })
      }
    }
  },
  mounted () {
    this.forceSSLAction()
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/global.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue